export default Backbone.Model.extend({
  supports_num_units_per_day() {
    return this.get('service_type').supports_num_units_per_day;
  },
  supports_recurring_billing() {
    return this.get('service_type').supports_recurring_billing;
  },
  is_end_date_exclusive() {
    return this.get('service_type').is_end_date_exclusive;
  },
  num_units_label() {
    return `How many ${this.units()} per day?`;
  },
  isHosting() {
    return this.get('service_type').location === 'provider_home';
  },
  isSDV() {
    return this.get('service_type').supports_service_delivery_verification;
  },
  units() {
    if (this.get('slug') === 'doggy-day-care') return 'day care';
    return `${this.standard_rate_add_on().unit}s`;
  },
  num_units_description() {
    return {
      singular: `${this.standard_rate_add_on().unit} per day`,
      plural: `${this.units()} per day`,
    };
  },
  standard_rate_add_on() {
    let srao = {};

    _.each(this.get('service_add_ons'), o => {
      if (o.slug === 'standard-rate') {
        srao = o;
      }
    });

    return srao;
  },
});



// WEBPACK FOOTER //
// ./js/backbone/models/service_button_group_model.js